import { defineComponent as r, computed as l, openBlock as s, createElementBlock as h, createElementVNode as t, toDisplayString as c, createCommentVNode as n, normalizeStyle as f, createStaticVNode as v } from "vue";
const p = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "0f0e0ba9-f76d-498d-a55b-7260f2a3d5bd" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#0f0e0ba9-f76d-498d-a55b-7260f2a3d5bd)" }, k = { key: 0 }, u = /* @__PURE__ */ v('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><path fill="#338af3" d="M289.4 133.6V256l78 40.4 77.9-40.4V133.6h-156z"></path><path fill="#a2001d" d="M289.4 256c0 59.6 77.9 78 77.9 78s78-18.4 78-78h-156z"></path><path fill="#333" d="M400.7 189.2h-22.3V167h-22.2v22.2h-22.3v22.3h22.3v66.8h22.2v-66.8h22.3z"></path>', 6), g = { fill: "none" }, V = ["r"], y = /* @__PURE__ */ r({
  __name: "ms",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), d = l(() => 256 + e.strokeWidth / 2);
    return (x, b) => (s(), h("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", m, [
        e.flagName ? (s(), h("title", k, c(e.flagName), 1)) : n("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, V)
      ])
    ], 8, p));
  }
});
export {
  y as default
};
//# sourceMappingURL=ms-e56ca7e4.js.map
